import { BodyRenderProps } from '~/components/BodyRender/models';
import { JsonRTEBlockProps } from '~/components/JsonRTEBlock/models';
import { RegisteredWrapperProps } from '~/components/RegisteredWrapper/models';

import { RegistredWrapperCmsItem } from './models';

export const registeredWrapperMapper = (
  item: RegistredWrapperCmsItem | null | undefined,
  currentPageUid: string,
  { jsonRTEImages }: { jsonRTEImages: JsonRTEBlockProps['rteImages'] }
): RegisteredWrapperProps => {
  if (!item)
    return {
      hideFor: undefined,
      body: [],
      rteImages: undefined,
      currentPageUid: '',
    };

  const { hide_for, body } = item;

  return {
    hideFor: hide_for,
    currentPageUid,
    body: (body ?? [])
      .map((bodyItem) => {
        if (!bodyItem.rte) return null;

        const {
          pageBlockUI: [pageBlockUI],
          componentId,
          rte,
        } = bodyItem.rte;
        if (!pageBlockUI) return null;

        return {
          htmlRTE: {
            typeName: 'HtmlRTEBlock',
            item: [] as unknown[],
            rte,
            componentId,
            pageBlockUI: [pageBlockUI],
          },
        };
      })
      .filter(Boolean) as unknown as BodyRenderProps['items'],
    rteImages: jsonRTEImages,
  };
};
